import { render, staticRenderFns } from "./OH-PH-Notice.vue?vue&type=template&id=617b574c&scoped=true&"
import script from "./OH-PH-Notice.vue?vue&type=script&lang=js&"
export * from "./OH-PH-Notice.vue?vue&type=script&lang=js&"
import style0 from "./OH-PH-Notice.vue?vue&type=style&index=0&id=617b574c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617b574c",
  null
  
)

export default component.exports